import React, { useState, useEffect, useCallback } from "react";

import logo from "../../assets/images/logosimple.svg";
import {
  BrowserRouter as Router,
  Route,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { Drawer, Select } from "antd";
import { useEnvironment } from "../../context/EnvironmentContext";
import { useSelector } from "react-redux";
import { change } from "../../redux/lang";
import tele from "../../assets/images/tele.jpeg";
import teleLogo from "../../assets/teleLogo.svg";
import chevronDown from "../../assets/arrowDown.svg";
import { IconsLoader } from "../../imports/icon";
import { useDispatch } from "react-redux";

export default function Header() {
  const auth = useSelector((state) => state.user);
  const navigation = useNavigate();
  const [open, setOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [webView, setWebView] = useState(false);
  const location = useLocation();
  const history = useNavigate();
  const pathname = location.pathname;
  const { isWebViewApp } = useEnvironment();
  const language = useSelector((state) => state.lang.language);
  const dispatch = useDispatch();
  console.log(pathname);
  console.log("Auth state in Header:", auth);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const changeLanguage = (lang) => {
    dispatch(change(lang));
  };

  const navigate = useCallback(
    (item) => {
      if (item.pathname !== pathname) {
        if (item.name === "signup") {
          console.log(item.name);
        } else {
          history(item.pathname);
        }
      }
    },
    [pathname]
  );

  const NavLinks = [
    {
      id: 1,
      name: language?.home || "Home",
      inactive: "home-empity",
      pathname: "/",
    },
    {
      id: 2,
      name: language?.games || "Games",
      inactive: "game-unfilled",
      pathname: "/games",
    },
    {
      id: 3,
      name: language?.profile || "Profile",
      inactive: "profileunfilled",
      pathname: "/auth",
    },
  ];

  return (
    <div className="relative">
      <nav className="flex bg-light-green justify-between pr-2 sm:pr-10 items-center w-[100%] mb-2 shadow-lg top-0 sticky z-10">
        <div className="py-3 pb-2 bg-white px-4 sm:px-8 rounded-tr-[35px]">
          <Link to={"/"}>
            <img
              alt="tele-logo"
              src={teleLogo || "/placeholder.svg"}
              className="w-32 sm:w-48"
            />
          </Link>
        </div>

        <div className="flex justify-between items-center space-x-4">
          {auth?.isLogedIn && (
            <ul className="text-white md:flex items-center hidden justify-center gap-3">
              {NavLinks.map((item, index) => {
                return (
                  <Link
                    className={`${
                      pathname === item?.pathname
                        ? "border-b-2 border-white font-gothaml"
                        : ""
                    } px-1`}
                    key={index}
                    to={item?.pathname}
                  >
                    {item.name}
                  </Link>
                );
              })}
            </ul>
          )}

          {/* Language dropdown */}
          <Select
            value={language?.lang}
            onChange={(value) => changeLanguage(value)}
            options={[
              { value: "am", label: "አማርኛ" },
              { value: "en", label: "English" },
              { value: "or", label: "Oromiffa" },
              { value: "af", label: "Afar" },
              { value: "ti", label: "ትግሪኛ" },
              { value: "so", label: "Somali" },
            ]}
            className="custom-select"
            size="large"
          />

          {/* Mobile menu button */}
          <button
            onClick={toggleSidebar}
            className="ml-4 p-2 bg-white rounded-md flex flex-col justify-center items-center md:hidden"
            aria-label="Toggle navigation sidebar"
          >
            <span className="block w-6 h-0.5 bg-light-green mb-1"></span>
            <span className="block w-6 h-0.5 bg-light-green mb-1"></span>
            <span className="block w-6 h-0.5 bg-light-green"></span>
          </button>
        </div>
      </nav>

      {/* Mobile Sidebar */}
      <div
        className={`fixed top-0 right-0 h-full w-64 bg-light-green text-white shadow-lg transform transition-transform duration-300 ease-in-out z-20 md:hidden ${
          sidebarOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="p-4 flex justify-between items-center border-b border-white/20">
          <h2 className="text-xl font-bold">
            {language?.ethiotelebrandingname || "Kinet Store"}
          </h2>
          <button
            onClick={toggleSidebar}
            className="text-white text-2xl"
            aria-label="Close sidebar"
          >
            &times;
          </button>
        </div>

        <div className="p-4">
          <ul className="space-y-4">
            {NavLinks.map((item, index) => (
              <li key={index}>
                <Link
                  to={item.pathname}
                  className={`block py-2 px-4 rounded transition-colors ${
                    pathname === item.pathname
                      ? "bg-white/20 font-bold"
                      : "hover:bg-white/10"
                  }`}
                  onClick={toggleSidebar}
                >
                  <span>{item.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="absolute bottom-0 w-full p-4 border-t border-white/20">
          <div className="flex flex-col gap-2">
            <div className="text-sm">
              <p>
                {language?.languageName || "Language"}: {language?.lang}
              </p>
            </div>
            <div className="flex flex-col gap-1 text-sm">
              <Link
                to="/terms-and-service"
                className="hover:text-white/80"
                onClick={toggleSidebar}
              >
                {language?.termandservice || "Terms and service"}
              </Link>
              <Link
                to="/privacy"
                className="hover:text-white/80"
                onClick={toggleSidebar}
              >
                {language?.privecyPolicy || "Privacy Policy"}
              </Link>
              {/* <Link
                to="/faq"
                className="hover:text-white/80"
                onClick={toggleSidebar}
              >
                FAQ
              </Link> */}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-10 md:hidden"
          onClick={toggleSidebar}
        ></div>
      )}
    </div>
  );
}
